import React from 'react';
import Head from 'next/head';
import classes from '../index.module.scss';
import MetaTags from 'src/components/metaTags/MetaTags';
const domainURL = process.env.NEXT_PUBLIC_REACT_APP_DOMAIN;

function EmpTermsOfUse() {
  let title = 'Employer Terms of Use';
  let link = domainURL + '/emp-terms-of-use';

  return (
    <React.Fragment>
      <MetaTags title={title} link={link} />
      <div className={classes['main-container']}>
        <div className={classes['container']}>
          <div className={classes['content-container']}>
            <div className={classes['title-content']}>
              <h1 className={classes['h1']}>Employer- Terms of use</h1>
              <br />
              <span className={classes['ccpa-last-updated-time']}>Last Updated: 11/30/2022</span>
            </div>
            <br />
            <div>
              <h1 className={classes['h1']}>Registered Employers</h1>
              <ul>
                <li>
                  <p className={classes['p']}>
                    Business registered on JobsHorn should be verifiable and provide State of business incorporation.
                  </p>
                </li>
                <li>
                  <p className={classes['p']}>
                    If business is not verified, we have the right to block business until information is provided to
                    activate the account.
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <h1 className={classes['h1']}>Job Postings</h1>
              <p className={classes['p']}>
                JobsHorn is in constant working to prevent job requirements abuse and server job seekers with valid
                jobs.
              </p>
              <ul>
                <li>
                  <p className={classes['p']}>
                    JobsHorn can block any job posting published and not as per standards and business cannot verify
                    detailed job duties.
                  </p>
                </li>
                <li>
                  <p className={classes['p']}>One job per posting, no directory of jobs posting.</p>
                </li>
                <li>
                  <p className={classes['p']}>Multiple copies of the same job posting.</p>
                </li>
                <li>
                  <p className={classes['p']}>
                    Posting same jobs and description and details under different locations nationwide.
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <h1 className={classes['h1']}>Resume Search</h1>
              <p className={classes['p']}>
                JobsHorn is thriving to provide high quality resumes to employers across US nationwide.
              </p>
              <ul>
                <li>
                  <p className={classes['p']}>Don’t share JobsHorn login with others.</p>
                </li>
                <li>
                  <p className={classes['p']}>ATS integration is allowed (Upcoming features).</p>
                </li>
                <li>
                  <p className={classes['p']}>Re-selling or distributing resumes acquired from JobsHorn.</p>
                </li>
                <li>
                  <p className={classes['p']}>
                    Robo-calls or marketing emails to emails and phone numbers obtained from JobsHorn.
                  </p>
                </li>
                <li>
                  <p className={classes['p']}>Illegal job offer to resources obtained from JobsHorn.</p>
                </li>
              </ul>
              <p className={classes['p']}>
                Apart from listed situations, anything that violates or complains received on job posting are considered
                to block and job posting or restrict user accounts access or business account restriction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default EmpTermsOfUse;
